<div class="section-list card">
  <div class="card-header tab-custom">
    <mat-progress-bar mode="indeterminate" *ngIf="loadinglist"></mat-progress-bar>
    <mat-tab-group class="my-mat-tab mat-tab-sm" [selectedIndex]="tab_selectedIndex"
      (selectedIndexChange)="tab_selectedIndex=$event">
      <mat-tab>
        <ng-template mat-tab-label>
          <i class="fas fa-list mr-1"></i> Supervisions
        </ng-template>
        <app-supervis-list [routeActive]="false" (supervisionSelectedEvent)="supervisionSelectedEventHandler($event)"></app-supervis-list>
      </mat-tab>
      <mat-tab *ngFor="let tab of tabsComponents; let index = index">
        <ng-template mat-tab-label>
          <i class="fa-eye far mr-1"></i> <span class="my-tab-title"
            matTooltip="{{tab.title}}">{{tab.title}}</span>
          <span class="tab-close" *ngIf="tab.isCloseable" (click)="closeTab(index,tab)">x</span>
        </ng-template>
        <frms-tab [tabTitle]="tab.title" [active]="tab.active" [component]="tab.component"
          [dataContext]="tab.dataContext">
        </frms-tab>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>